/**
 * usePageTracking Hook
 * Automatically tracks page views when route changes
 * Use this hook once at the app root level (e.g., in AppRoutes)
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, isGA4Initialized } from './ga4';

export function usePageTracking(): void {
  const location = useLocation();
  const previousPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isGA4Initialized()) {
      return;
    }

    if (previousPathRef.current !== location.pathname) {
      previousPathRef.current = location.pathname;
      
      trackPageView({
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location]);
}
